import React from "react";
import { Shield, Star, Flame, Users, Crown, Award } from "lucide-react";

export function memberYears(approved_at) {
  if (!approved_at) return 0;
  const a = new Date(approved_at);
  const now = new Date();
  let y = now.getFullYear() - a.getFullYear();
  const m = now.getMonth() - a.getMonth();
  if (m < 0 || (m === 0 && now.getDate() < a.getDate())) y--;
  return Math.max(0, y);
}

export function getMemberBadges(user) {
  if (!user) return [];
  const out = [];
  if (user.role === "admin") {
    out.push({ key: "staff", label: "Staff", bg: "#121212", fg: "#F4F0E6", Icon: Shield });
  } else if (user.membership_status === "approved") {
    const y = memberYears(user.approved_at);
    out.push({ key: "tier", label: y >= 1 ? `${y}-Year Member` : "Club Initiate", bg: "#8B1E28", fg: "#F4F0E6", Icon: Star });
    if (y >= 5) out.push({ key: "vet", label: "Veteran", bg: "#C7A656", fg: "#121212", Icon: Flame });
    const r = user.referral_count || 0;
    if (r >= 1 && r < 3) out.push({ key: "rec", label: `Recruiter · ${r}`, bg: "#C7A656", fg: "#121212", Icon: Users });
    if (r >= 3 && r < 5) out.push({ key: "rec3", label: "Club Recruiter", bg: "#C7A656", fg: "#121212", Icon: Users });
    if (r >= 5) out.push({ key: "legend", label: "Club Legend", bg: "#121212", fg: "#C7A656", Icon: Crown });
  } else if (user.membership_status === "pending") {
    out.push({ key: "prospect", label: "Prospect", bg: "#DCD4BC", fg: "#121212", Icon: Star });
  }
  (user.custom_badges || []).forEach((label, i) => out.push({ key: `custom-${i}-${label}`, label, bg: "#2A2118", fg: "#C7A656", Icon: Award }));
  return out;
}

export function MemberBadges({ user, center = false }) {
  const badges = getMemberBadges(user);
  if (!badges.length) return null;
  return (
    <div className={`flex flex-wrap gap-2 ${center ? "justify-center" : ""}`} data-testid="member-badges">
      {badges.map((b) => (
        <span
          key={b.key}
          className="inline-flex items-center gap-1 border-2 border-black rounded px-2 py-1 font-mono2 text-[10px] uppercase tracking-wide"
          style={{ background: b.bg, color: b.fg }}
          data-testid={`badge-${b.key}`}
        >
          <b.Icon size={12} /> {b.label}
        </span>
      ))}
    </div>
  );
}
